import { render, staticRenderFns } from "./ZiyaratAdd.vue?vue&type=template&id=0d127a95&scoped=true&"
import script from "./ZiyaratAdd.vue?vue&type=script&lang=js&"
export * from "./ZiyaratAdd.vue?vue&type=script&lang=js&"
import style0 from "./ZiyaratAdd.vue?vue&type=style&index=0&id=0d127a95&prod&scoped=true&lang=css&"
import style1 from "./ZiyaratAdd.vue?vue&type=style&index=1&id=0d127a95&prod&lang=css&"
import style2 from "./ZiyaratAdd.vue?vue&type=style&index=2&id=0d127a95&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d127a95",
  null
  
)

export default component.exports